var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.498,
    viewBox: "0 0 21.5 21.498",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M9.368,3a1.053,1.053,0,0,1,.923.546l.054.116,2.105,5.263a1.053,1.053,0,0,1-.329,1.221l-.105.072-1.762,1.057.066.108a10.526,10.526,0,0,0,3.3,3.3l.107.065,1.058-1.76a1.053,1.053,0,0,1,1.172-.477l.121.041,5.263,2.105a1.053,1.053,0,0,1,.655.849l.007.127v4.211A3.169,3.169,0,0,1,18.779,23,17.9,17.9,0,0,1,2,6.158,3.158,3.158,0,0,1,4.973,3.005L5.158,3H9.368Z",
    transform: "translate(-1.25 -2.25)",
    fill: "none",
    stroke: "#0a1e5b",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.faa681ab4e23893db0562f1c0ee0641d.svg";
export { ForwardRef as ReactComponent };